import React from "react"

function Headings(){
    return(

        <h3 className="headings">
                <span className="id-col">ID</span>
                <span className="username-col" id="namecol">Username</span>
                <span className="date-col">Application Date</span>
                <span className="track-col">Track</span>
                <span className="city-col">City</span>
                <span className="status-col">Status</span>
                <span className="date-col">Update</span>
                <span className="history-col">History</span>

            </h3>
    )
}

export default Headings